import {
  ClashsetNotificationSettings,
  CommentNotificationSettings,
  FileNotificationSettings,
  FolderNotificationSettings,
  OtherNotificationSettings,
  ReleaseNotificationSettings,
  TodoNotificationSettings,
  UserNotificationSettings,
  ViewNotificationSettings,
} from '../../generated/index';
import { SettingsDetails } from '@trimble/types';

export const mapToTcpsModel = (
  input: SettingsDetails
):
  | FileNotificationSettings
  | FolderNotificationSettings
  | CommentNotificationSettings
  | UserNotificationSettings
  | ViewNotificationSettings
  | ClashsetNotificationSettings
  | ReleaseNotificationSettings
  | TodoNotificationSettings
  | OtherNotificationSettings => ({
  activityId: input.activityId,
  activityName: input.activityName,
  activityNotificationSettingId: input.activityNotificationSettingId,
  dailyDigestNotification: input.dailyDigestNotification,
  instantNotification: input.instantNotification,
});

export const mapToDomain = (
  input:
    | FileNotificationSettings
    | FolderNotificationSettings
    | CommentNotificationSettings
    | UserNotificationSettings
    | ViewNotificationSettings
    | ClashsetNotificationSettings
    | ReleaseNotificationSettings
    | TodoNotificationSettings
    | OtherNotificationSettings
): SettingsDetails => ({
  activityId: input.activityId,
  activityName: input.activityName,
  activityNotificationSettingId: input.activityNotificationSettingId,
  dailyDigestNotification: input.dailyDigestNotification,
  instantNotification: input.instantNotification,
});
